<div [class.show]="!isChecked"></div>

<div *ngIf="isEstampPending" class="estamp-pending-overlay">
  <div class="estamp-pending-card">
    <div class="estamp-pending-accent"></div>
    <img src="../../../assets/img/new-logo.png" class="estamp-pending-logo" alt="Doqfy" />
    <div class="estamp-pending-spinner">
      <span></span>
      <span></span>
    </div>
    <h5 class="estamp-pending-title">Document in Process</h5>
  </div>
</div>

<div *ngIf="!isDocumentSigned && !isEstampPending" class="bcg_esign">
    <div class="sign-topbar">
      <div class="sign-topbar-brand">
        <img src="../../../assets/img/new-logo.png" class="sign-topbar-logo" />
        <div class="session-timer" [class.session-timer-warning]="sessionTimeLeft <= 60">
          <i class="pi pi-clock"></i>
          <span class="session-timer-label">Session expires in</span>
          <span class="session-timer-value">{{ sessionTimerDisplay }}</span>
        </div>
      </div>
      <div *ngIf="showSign && !isHashSign" class="sign-topbar-pager">
        <input class="pager-input" [(ngModel)]="pageNo" type="number" [min]="1" [max]="numPdfPages" />
        <button class="pager-go-btn" (click)="pageChange(pageNo)">Go</button>
        <span class="pager-info">{{ numPdfPages }} pages</span>
      </div>
    </div>

    <p-dialog [(visible)]="displayConsentModal" [modal]="true" [closable]="false" [draggable]="false"
      [resizable]="false" [showHeader]="false" styleClass="consent-modal"
      [style]="{ width: '500px', maxWidth: '90vw' }">

      <div [ngStyle]="{ zoom: showSign ? '1' : '0.8' }" class="card card_outLine p-3">

        <!-- Consent paragraph -->
        <p class="r1s_small mb-3">{{ 'CONSENT.TEXT' | translate }}</p>

        <!-- Checkbox row + language dropdown on same line -->
        <div class="d-flex align-items-center justify-content-between gap-2 mb-1">
          <div class="d-flex align-items-start gap-2">
            <input type="checkbox" (change)="onCheckboxChange($event)"
              [class.highlighted]="!isChecked && signerData.length > 0" [class.blinking]="!isChecked"
              class="form-check-input mt-1 me-1" [disabled]="signerData.length < 1" />
            <span class="r1s_small">{{ 'CONSENT.CHECKBOX_LABEL' | translate }}</span>
          </div>
          <app-dropdown
            class="flex-shrink-0 consent-language-dropdown"
            style="font-size: 0.75rem;"
            [options]="consentLanguages"
            optionLabel="label"
            optionValue="code"
            [sort]="false"
            [(ngModel)]="selectedConsentLang"
            appendTo="body"
            panelStyleClass="esign-consent-dropdown-panel"
            (onChange)="translate.use(selectedConsentLang)"
          ></app-dropdown>
        </div>

        <!-- Helper text -->
        <div class="mt-1" style="font-size: 0.72rem; color: #6c757d;">
          ({{ 'CONSENT.HELPER_TEXT' | translate }})
        </div>

      </div>

    </p-dialog>

    <p-dialog header="Signature Failed" [(visible)]="showFileCorruptedDialog"
      [style]="{ width: '500px', maxWidth: '90vw',height: '35vh' }" [modal]="true" [draggable]="false"
      [resizable]="false" [closable]="false">

      <div class="p-1 text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 2.5rem; color: #ff7b00;"></i>
        <!-- <h4 class="mt-1">File is Corrupted</h4> -->
        <h6 class="mt-2 mb-2">Signature capture unsuccessful. Please try again.</h6>
      </div>

      <ng-template pTemplate="footer">
        <p-button class="mt-2" label="Try Again" icon="pi pi-refresh" (onClick)="onRetryClicked()"
          styleClass="try-button">
        </p-button>
        <!-- <p-button 
      label="Cancel" 
      icon="pi pi-times"
      (onClick)="onCloseModal()"
      styleClass="p-button-secondary ml-2">
    </p-button> -->
      </ng-template>
    </p-dialog>


    <div class="row mt-2 esign-content-row">
      <!-- Left column (PDF viewer) -->
      <div class="col-12 col-lg-8 mb-4 esign-scroll-pane" #scrollPane>
        
        <div *ngIf="isHashSign" class="card card_outLine p-4 hash-sign-panel">
          <h5 class="mb-3">Signing by document hash</h5>
          <p class="r1s_small mb-3">
            You are signing the document identified by the hash below. The document itself stays
            with the requesting organisation and is not shown here.
          </p>
          <div *ngIf="hashFilename" class="mb-2">
            <span class="r1s_small text-muted">File name</span>
            <div class="hash-sign-value">{{ hashFilename }}</div>
          </div>
          <div>
            <span class="r1s_small text-muted">{{ hashAlgorithm }} hash</span>
            <div class="hash-sign-value hash-sign-digest">{{ documentHash }}</div>
          </div>
          <p *ngIf="hashWaiting" class="r1s_small mt-3 mb-0 hash-sign-waiting">
            Waiting for earlier signers to complete. You will receive the signing link when it is your turn.
          </p>
        </div>

        <app-pdf-virtual-viewer
          *ngIf="!isHashSign"
          #pdfViewer
          [pdfData]="pdfUrl"
          [scrollRoot]="scrollPaneRef?.nativeElement"
          [overlayPages]="overlayPages"
          (docLoaded)="onDocLoaded($event)"
          (pageRendered)="onPageRendered($event)"
        >
          <ng-template let-pageNum>
            <ng-container *ngFor="let item of positionDetails?.[pageNum] || []">
              <div
                class="custom_button_1 example-box-placeholder"
                [style.transform]="getPosition(item, pageNum)"
                [style.width.px]="getBoxSizePx(item).width"
                [style.height.px]="getBoxSizePx(item).height"
                title="Your signature will appear here"
              >
                <i class="pi pi-verified"></i>
                <span>Signature Area</span>
              </div>
            </ng-container>
          </ng-template>
        </app-pdf-virtual-viewer>
      </div>
      <!-- Right column (Details and buttons) -->
      <div class="col-12 col-lg-4 esign-scroll-pane">
        <div class="card card_outLine mb-3" style="position: relative; padding: 0">
          <div *ngIf="webcamImage">
            <div class="card-header title_five">
              <span class="title_five">Signer Image</span>
            </div>
            <div class="card-body">
              <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center">
                <div>
                  <img class="clickable img-fluid" [src]="webcamImage" height="150" width="200" />
                </div>
                <div class="ms-0 ms-sm-4 mt-3 mt-sm-0">
                  <p-button label="Retake" styleClass="p-button-sm-outline" (click)="loadCam(userImage)"></p-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card card_outLine mb-3" style="position: relative; padding: 0">
          <div class="card-header title_five">Signature Details</div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-sm-6">
                <span class="r1">Order ID:<span class="r1s">{{ orderId }}</span></span><br />
                <span class="r1">Name:<span class="r1s">{{
                    signatoryDetails?.name
                    }}</span></span><br />
              </div>
              <div class="col-12 col-sm-6 mt-2 mt-sm-0">
                <span class="r1">Email:<span class="r1s">{{
                    signatoryDetails?.email
                    }}</span></span><br />
                <span class="r1">Contact:<span class="r1s">{{
                    signatoryDetails.contact_number
                    }}</span></span>
              </div>
            </div>
          </div>
        </div>

        <div class="card card_outLine mb-3" style="position: relative; padding: 0">
          <div class="card-header title_five">Summary</div>
          <div class="card-body">
            <div class="mt-3">
              <p class="r1s">
                &#9658; The document will be sent to your email upon completion
                by all signers.
              </p>
            </div>
            <div *ngIf="totalSignaturePositions > 0" class="mt-3">
              <p class="r1s">
                &#9658; {{ totalSignaturePositions }} signature position{{ totalSignaturePositions === 1 ? '' : 's' }}
                assigned to you.
              </p>
            </div>
            <div class="mt-3">
              <p *ngIf="signatoryDetails.signatory_sequence === 1" class="r1s">
                &#9658; Your are the first one to open the Document.
              </p>
            </div>
            <div *ngIf="zeroSigners.length != 0" class="r1s">
              <ng-container *ngFor="let signer of zeroSigners; let last = last">
                <span>
                  &#9658; E-sign link has been sent to
                  <span class="r1 ms-2">{{ signer.name }}</span>{{ !last ? " ," : " ." }}<br /></span>
              </ng-container>
            </div>

            <div *ngIf="
                signatoryDetails.status === 'CANCELLED' ||
                signatoryDetails.status === 'EXPIRED'
              " class="my-3" style="display: flex; justify-content: center">
              <img src="../../../assets/img/sign-cancelled.png" height="200" />
            </div>
            <div *ngIf="completedSigners.length != 0" class="r1s">
              <ng-container *ngFor="let signer of completedSigners; let last = last">
                <span>
                  &#9658; Document has been Signed by
                  <span class="r1 ms-2">{{ signer.name }}</span>.<br /></span>
              </ng-container>
            </div>
            <div *ngIf="signatoryDetails.status === 'EXPIRED'" class="p-3">
              <h4 class="title_five">The Signature is Expired.</h4>
            </div>
            <div *ngIf="signatoryDetails.status === 'COMPLETED'" class="p-1">
              <h4 class="title_five" style="display: flex; justify-content: center">
                Thank You
              </h4>
            </div>
          </div>
        </div>
        <div *ngIf="showEmudhra" class="card card_outLine mb-3 sign-action-card" style="padding: 0">
          <div
             *ngIf="selectMethod === 'AADHAAR'"
              class="sign-now-row"
             [class.center-sign-now]="!signerData.enable_esign_options"
            >
            <div *ngIf="signerData.enable_esign_options"
            class="sign-method-group">
              <span class="sign-method-label">Sign Mode:</span>
              <app-dropdown
                class="custom-dropdown sign-method-dropdown"
                [options]="aadhaarVerificationMethod"
                [(ngModel)]="selectedVerificationMethod"
                optionLabel="name"
                optionValue="code"
                optionDisabled="inactive"
                placeholder="Select Method"
                [autoDisplayFirst]="false"
                appendTo="body">
              </app-dropdown>
            </div>
            <p-button *ngIf="!hashWaiting" label="Sign Now" (click)="loadEsignData(emudhraSign)" styleClass="p-button-sm-outline sign-now-btn">
            </p-button>
          </div>
          <div *ngIf="selectMethod === 'DSC'" class="d-flex justify-content-center align-items-center">
            <p-button label="Sign Now" (click)="loadEsignDataDSC()" styleClass="p-button-sm-outline m-3">
            </p-button>
          </div>
        </div>

        <!-- Loading Overlay with Custom GIF -->
        <div *ngIf="isLoading" class="loading-overlay">
          <div class="loader-content">
            <img src="/assets/img/doqfy-load.gif" style="height: 120px" alt="Loading..." />
            <p style="color: #ffffff">Your data is getting prepared...</p>
          </div>
        </div>

        <div *ngIf="!showEmudhra && !hashWaiting" class="card card_outLine mb-3 sign-action-card" style="padding: 0">
          <div class="d-flex justify-content-center align-items-center">
            <p-button label="Sign Now" (click)="openPopup(userImage)" styleClass="p-button-sm-outline m-3">
            </p-button>
          </div>
        </div>

        <div *ngIf="enableCaptureImage && !webcamImage" class="card card_outLine mb-3">
          <div class="card-header">Capture Image</div>
          <div class="card-body capture-section">
            <div class="capture-icon">
              <i class="pi pi-camera"></i>
            </div>
            <span class="capture-title">Take a selfie</span>
            <span class="capture-desc">Required for identity verification</span>
            <button class="sign-panel-btn" (click)="loadCam(userImage)">
              <i class="pi pi-camera me-2"></i> Open Camera
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

<div *ngIf="isDocumentSigned && !isEstampPending" class="bcg_esign" style="justify-content: center; align-items: center; display: flex">
  <div class="card card_outLine">
    <div style="padding: 3rem 5rem">
      <img *ngIf="signatoryDetails.status === 'COMPLETED'" src="/assets/img/animation-crop.gif" class="sign-animation"
        alt="animation" />
      <div style="display: flex; justify-content: center; align-items: center">
        <img class="clickable" src="../../assets/img/new-logo.png" height="60" />
      </div>

      <div *ngIf="signatoryDetails.status === 'COMPLETED'" class="my-4" style="display: flex; justify-content: center">
        <img src="../../../assets/img/sign-completed.png" height="60" />
      </div>


      <p *ngIf="signatoryDetails.status === 'COMPLETED' && isHashSign" class="r1s_small text-center mt-4">
        Your signature over the document hash has been recorded and sent to the requesting organisation.
      </p>

      <div class="action-buttons mt-4" *ngIf="signatoryDetails.status === 'COMPLETED' && !isHashSign">
        <button class="action-btn email-btn" (click)="shareToEmail()" [disabled]="isEmailButtonDisabled"
          [class.disabled]="isEmailButtonDisabled">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          <span *ngIf="!isEmailButtonDisabled">Email to me</span>
          <span *ngIf="isEmailButtonDisabled">Wait {{ emailCooldownTime }}s</span>
        </button>

        <button class="action-btn print-btn" (click)="printDocument()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="6 9 6 2 18 2 18 9"></polyline>
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
            <rect x="6" y="14" width="12" height="8"></rect>
          </svg>
          Print
        </button>

        <button class="action-btn download-btn" (click)="downloadDocument()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="7 10 12 15 17 10"></polyline>
            <line x1="12" y1="15" x2="12" y2="3"></line>
          </svg>
          Download
        </button>
      </div>

      <div *ngIf="signatoryDetails.status === 'COMPLETED'" class="p-3">
        <h4 class="title_five">Document Signed Successfully</h4>
      </div>

      <div *ngIf="
          signatoryDetails.status === 'CANCELLED' ||
          signatoryDetails.status === 'EXPIRED'
        " class="my-3" style="display: flex; justify-content: center">
        <img src="../../../assets/img/sign-cancelled.png" height="200" />
      </div>
      <div *ngIf="signatoryDetails.status === 'CANCELLED'" class="p-3">
        <h4 class="title_five">The Signature is Cancelled.</h4>
      </div>
      <div *ngIf="signatoryDetails.status === 'EXPIRED'" class="p-3">
        <h4 class="title_five">The Signature is Expired.</h4>
      </div>
      <div *ngIf="signatoryDetails.status === 'COMPLETED'" class="p-1">
        <h4 class="title_five" style="display: flex; justify-content: center">
          Thank You
        </h4>
      </div>
    </div>
  </div>
</div>

<ng-template #userImage let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">Capture Image</h4>
  </div>

  <div class="modal-content" *ngIf="!isSignFailed">
    <div class="modal-body" style="background-color: #f3eeee; height: 100%; padding: 5px">
      <app-kyc-details [showWebcam]="showWebcam" (initError)="handleInitError($event)" [orderId]="orderId" (pictureTaken)="handleImage($event)"></app-kyc-details>
    </div>
  </div>
</ng-template>

<ng-template #otpScreen let-modal>
  <!-- <div class="modal-header">
        <h4 class="title_five" id="modal-basic-title">OTP Validation</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()"
            aria-label="Close"></button>
    </div> -->
  <div class="modal-content">
    <div class="modal-body">
      <div class="text-center" style="zoom: 80%">
        <div *ngIf="!sendOtpLink && !isSignFailed" class="form-signin">
          <div class="radius_border text-left">
            <img alt="" class="mb-4" style="height: 3rem" src="../../assets/img/new-logo.png" />
            <div class="container">
              <div>
                <ng-container *ngIf="signatoryDetails?.is_sms; else emailOnly">
                  An OTP will be sent to {{ signatoryDetails?.email }} and
                  {{ signatoryDetails?.contact_number }} for verification.
                </ng-container>
                <ng-template #emailOnly>
                  An OTP will be sent to {{ signatoryDetails?.email }} for
                  verification.
                </ng-template>
              </div>
              <div class="mt-4">
                <button (click)="resendOtp()" class="btn btn-primary ms-2" style="background-color: rgb(74, 11, 119)">
                  Send OTP
                </button>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="sendOtpLink" class="form-signin">
          <div class="radius_border text-left">
            <img alt="" class="mb-4" style="height: 3rem" src="../../assets/img/new-logo.png" />
            <div class="container">
              <div>
                <ng-container *ngIf="signatoryDetails?.is_sms; else emailOnly2">
                  A 6-digit code has been sent to
                  {{ signatoryDetails?.email }} and
                  {{ signatoryDetails?.contact_number }}. Enter the code to
                  Proceed.
                </ng-container>
                <ng-template #emailOnly2>
                  A 6-digit code has been sent to {{ signatoryDetails?.email }}.
                  Enter the code to Proceed.
                </ng-template>
              </div>

              <div class="tab-content mt-4" id="pills-tabContent">
                <div>
                  <div class="otp_section">
                    <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" *ngIf="showOtpComponent"
                      [config]="config"></ng-otp-input>
                  </div>

                  <div class="row">
                    <div class="mt-3">
                      <button [disabled]="enableOtp" (click)="otpOnSubmit()" class="btn btn-primary"
                        style="background-color: rgb(74, 11, 119)">
                        Submit
                      </button>
                      <button *ngIf="timeLeft === 0" (click)="resendOtp()" class="btn btn-primary ms-2"
                        style="background-color: rgb(74, 11, 119)">
                        Resend OTP
                      </button>
                      <div class="font-weight-bold mt-3 cursor">
                        <span class="resend-otp">Resend OTP </span>
                        <span class="resend-otp-timer">
                          in {{ timeLeft }} Sec</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #geoFencingModal let-modal>
  <div class="modal-content geo-fencing-specific">
    <div class="modal-body text-center p-4">
      <div class="mb-4">
        <i class="fas fa-globe-americas fa-3x text-danger"></i>
      </div>
      <h5 class="mb-3 font-weight-bold">Access Restricted</h5>
      <p class="text-muted mb-3">
        You're protected by Doqfy's security. Document signing is not available
        from your current location.
      </p>
      <div class="alert alert-light border small mb-4">
        <div class="d-flex justify-content-between">
          <span class="text-muted">Detected Location:</span>
          <span class="font-weight-bold">{{ geoFencingData?.country }}</span>
        </div>
        <div class="d-flex justify-content-between mt-2">
          <span class="text-muted">IP Address:</span>
          <span class="font-weight-bold">{{ geoFencingData?.ip_address }}</span>
        </div>
      </div>
      <button type="button" class="btn btn-primary btn-sm-block" (click)="modal.close('close')">
        Acknowledge
      </button>
    </div>
  </div>
</ng-template>

<ng-template #emudhraSign let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">Aadhaar Validation</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeEmudhraModel()"
      aria-label="Close"></button>
  </div>

  <div class="modal-content">
    <div class="modal-body" style="background-color: #f3eeee; height: 100%">
      <iframe [src]="pdfSource" sandbox="allow-scripts allow-same-origin allow-forms allow-top-navigation" allow="local-network-access" class="col-md-12 text-center this-is-iframe" style="
          width: 100%;
          height: 80vh;
          border: 1px solid #ccc;
          background-color: #ffffff;
          zoom: 1;
        "></iframe>
    </div>
  </div>
</ng-template>

<ng-template #emudhraSignDSC let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">DSC Validation</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeEmudhraModel()"
      aria-label="Close"></button>
  </div>

  <div class="modal-content">
    <div class="modal-body" style="background-color: #f3eeee; height: 100%">
      <div style="text-align: center">
        <strong class="r1s_small">You are being redirected to emSigner portal</strong><br />
        <strong class="r1s_small" style="color: blue; margin: 1rem 0rem;">Please wait ...</strong><br />
        <strong class="r1s_small">(Please do not press 'Refresh' or 'Back' button)</strong>
      </div>

      <form id="signDocForm" name="signDocForm" method="post" [action]="pdfSource" (ngSubmit)="submitForm()">
        <input type="hidden" name="Parameter1" id="Parameter1" [value]="parameters.Parameter1" />
        <input type="hidden" name="Parameter2" id="Parameter2" [value]="parameters.Parameter2" />
        <input type="hidden" name="Parameter3" id="Parameter3" [value]="parameters.Parameter3" />
      </form>
    </div>
  </div>
</ng-template>